if (!customElements.get('product-warning')) customElements.define('product-warning', class extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    const dialog=this.querySelector('dialog');
    if (!dialog?.showModal) return;
    this.ready=true;
    const trigger=this.querySelector('[data-warning-trigger]');
    this.querySelector('[data-warning-modal-copy]').innerHTML=this.querySelector('[data-warning-copy]').innerHTML;
    trigger.setAttribute('aria-haspopup','dialog');
    trigger.addEventListener('click',event=>{event.preventDefault();dialog.showModal();this.querySelector('[data-warning-close]').focus();});
    this.querySelector('[data-warning-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>trigger.focus());
    dialog.addEventListener('keydown',event=>{
      if(event.key==='Escape'){event.preventDefault();dialog.close();return;}
      if(event.key!=='Tab')return;
      const items=[...dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]')];
      const first=items[0],last=items.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    });
  }
});
